import Geometry from "@frog/source/utility/Geometry.js"

export default class World {
    static getTerrain(world, position) {
        if(position == undefined) {
            return undefined
        }
        if(world.terrain[position.x + "x" + position.y] != undefined) {
            return world.terrain[position.x + "x" + position.y]
        }
    }
    static isInBounds(world, position) {
        return position.x < 0
            || position.y < 0
            || position.z < 0
            || position.x >= world.width
            || position.y >= world.height
            || position.z >= world.depth
    }
    static hasCollision(world, previousPosition, nextPosition, options = {}) {
        const isIgnoringLedges = options.isIgnoringLedges || false
        const isIgnoringWallEdges = options.isIgnoringWallEdges || false
        if(isIgnoringLedges == false
        && World.isInBounds(world, nextPosition)) {
        // if(World.isInBounds(world, nextPosition)) {
            return true
        }
        if(isIgnoringWallEdges == false
        && previousPosition != undefined) {
            const direction2 = Geometry.direction(previousPosition, nextPosition)
            const direction1 = Geometry.flip(direction2)
            const key1 = previousPosition.x + "x" + previousPosition.y + "x" + previousPosition.z + "/" + (direction1.x > 0 ? "+" : "") + direction1.x + "x" + (direction1.y > 0 ? "+" : "") + direction1.y
            const key2 = nextPosition.x + "x" + nextPosition.y + "x" + nextPosition.z + "/" + (direction2.x > 0 ? "+" : "") + direction2.x + "x" + (direction2.y > 0 ? "+" : "") + direction2.y
            let edge1 = world.edges[key1]
            let edge2 = world.edges[key2]
            if(edge1 != undefined
            || edge2 != undefined) {
                return true
            }
        }
        const terrain = world.terrain[nextPosition.x + "x" + nextPosition.y]
        if(terrain != undefined) {
            if(isIgnoringLedges == false
            || nextPosition.z < terrain.position.z) {
                try {
                    if(Math.abs(nextPosition.z - terrain.position.z) > 0.5) {
                        return true
                    }
                } catch(error) {
                    console.log(nextPosition, terrain, world)
                    throw error
                }
            }
        }
        // if(previousPosition != undefined
        // && terrain.shape == "ramp") {
        //     if((terrain.direction == "east" || terrain.direction == "west")
        //     && previousPosition.y != nextPosition.y) {
        //         return true
        //     }
        //     if((terrain.direction == "south" || terrain.direction == "north")
        //     && previousPosition.x != nextPosition.x) {
        //         return true
        //     }
        // }
        return false
    }
    static getHighestBlock(world, position) {
        if(position == undefined) {
            return undefined
        }
        let highblock = undefined
        world.blocks.forEach((block) => {
            if(block.position.x == position.x
            && block.position.y == position.y) {
                if(highblock == undefined) {
                    highblock = block
                } else if(block.position.z + block.size.z > highblock.position.z + highblock.size.z) {
                    highblock = block
                }
            }
        })
        return highblock || {
            "position": position,
            "size": {"z": 0},
            "shape": "block"
        }
    }
}
